import { addMonths } from 'date-fns';
import { parseApiDate } from './data';

/** Realce da coluna Início do Pool (T21): quanto mais tempo no pool, mais forte. */
export type PoolTenureTone = 'warning' | 'danger' | null;

/**
 * Tom do realce pelo tempo no pool, medido de `startDate` até a data de
 * referência da consulta: acima de 2 meses → `danger` (vermelho), acima de 1
 * mês → `warning` (laranja), abaixo disso → `null` (sem realce).
 */
export function poolTenureTone(
  startDate: string | null | undefined,
  referenceDate: string | null | undefined,
): PoolTenureTone {
  const start = parseApiDate(startDate);
  const reference = parseApiDate(referenceDate);
  if (!start || !reference) return null;
  if (reference >= addMonths(start, 2)) return 'danger';
  if (reference >= addMonths(start, 1)) return 'warning';
  return null;
}
